interface ImageLoaderParams {
  src: string;
  width: number;
  quality?: number;
}

const LAMBDA_BASE = process.env.IMAGE_LAMBDA_URL!;

export default function imageLoader({
  src,
  width,
  quality,
}: ImageLoaderParams): string {
  const transforms = `c_scale,f_auto,w_${width},q_${quality || 75}`;
  return `${LAMBDA_BASE}/image/fetch/${transforms}/${encodeURIComponent(src)}`;
}
